import * as types from "./constants";

export const initialImageData = (image) => {
  return (dispatch) => {
    dispatch({
      type: types.INITIAL_IMAGE_DATA,
      image: image,
    });
  };
};

export const saveImageData = (image) => {
  return (dispatch) => {
    dispatch({
      type: types.SAVE_IMAGE_DATA,
      image: image,
      loading: false,
    });
  };
};
